import { buildWorkSignupHref } from "@/lib/signup-next";

export type CtaRole = "candidate" | "employer" | "browse_jobs";

/**
 * Source slugs are developer-controlled (e.g. "guide:ibiza",
 * "festival:glastonbury-jobs") and already URL-safe, so the employer link
 * interpolates them verbatim, keeping the analytics URLs readable. Candidate
 * links carry work intent and return to `jobsHref` (default `/jobs`) so the
 * work setup step is never skipped.
 */
export function ctaHref(
  role: "candidate" | "employer",
  source: string,
  jobsHref?: string,
): string {
  if (role === "candidate") {
    return buildWorkSignupHref({ next: jobsHref ?? "/jobs", source });
  }
  return `/employer-signup?source=${source}`;
}

export function bannerHeading(context?: string): string {
  return context ? `Working a season in ${context}?` : "Ready for your next season?";
}

export function browseJobsLabel(context?: string): string {
  return context ? `or browse jobs in ${context} →` : `or browse jobs →`;
}

export function ctaEvent(
  role: CtaRole,
  source: string,
  context?: string,
): { role: CtaRole; source: string; context: string | null } {
  return { role, source, context: context ?? null };
}
